import { FormControl, FormControlLabel, Radio, RadioGroup, useTheme } from "@mui/material";
import React from "react";

const RadioGroupComponent = ({
    name,
    value,
    handleChange,
    options,
    disabled
}: {
    name: string,
    value: string,
    handleChange: Function,
    options: any[],
    disabled: boolean
}) => {

    // Use Theme
    const theme = useTheme();

    return (
        <FormControl  >
            <RadioGroup
                row
                name={ name }
                value={ value }
                onChange={ (e, value) => handleChange(e, value) }
                color={ "accent" }
            >
                { options.map(el => (
                    <FormControlLabel
                        key={ el.id }
                        value={ el.id }
                        label={ el.label }
                        control={ <Radio
                            sx={ {
                                color: theme.palette.accent.main,
                                "&.Mui-checked": {
                                    color: theme.palette.accent.main
                                }
                            } }
                        /> }
                        disabled={ disabled }
                    />
                )) }
            </RadioGroup>
        </FormControl>
    );
};

export default RadioGroupComponent;